import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useFetch from 'hooks/useFetch';
import { selectJohnDeereOrgs, slice } from 'hooks/useJohnDeere/state';

import { ORGANIZATIONS_API } from './constants';
import type { JohnDeereOrganization, UseJohnDeereOrganizationsReturn } from './types';

const FETCH_PARAMS = {
    apiHost: import.meta.env.VITE_JD_API_BASE_URL || '',
    headers: { 'Content-Type': 'application/json' }
};

const useJohnDeereOrganizations = (): UseJohnDeereOrganizationsReturn => {
    const dispatch = useDispatch();
    const organizations = useSelector(selectJohnDeereOrgs);
    const [isLoading, setIsLoading] = useState(false);

    const { authenticatedGet } = useFetch(FETCH_PARAMS);

    const fetch = useCallback(async () => {
        try {
            setIsLoading(true);

            const response = await authenticatedGet<JohnDeereOrganization[]>(ORGANIZATIONS_API);

            if (response.data) {
                dispatch(slice.actions.setConnectedOrgs(response.data));
            }

            if (response.error) {
                console.error('Failed to fetch John Deere organizations:', response.error);
            }
        } finally {
            setIsLoading(false);
        }
    }, [authenticatedGet, dispatch]);

    return {
        fetch,
        isLoading,
        organizations
    };
};

export default useJohnDeereOrganizations;
